import React from 'react';
import PropsTypes from 'prop-types';
import { Legend } from 'react-jsx-highcharts';

const ChartLegend = ({ disableHover = false, reversed }) => {
    return (
        <Legend
            reversed={reversed}
            symbolHeight={10}
            symbolRadius={0}
            verticalAlign="top"
            itemDistance={20}
            itemStyle={{
                fontSize: '12px',
                fontWeight: 400,
                color: '#64748B',
            }}
            itemHoverStyle={
                disableHover
                    ? {
                          color: '#64748B',
                          cursor: 'default',
                          opacity: 1,
                      }
                    : {}
            }
        />
    );
};

ChartLegend.propTypes = {
    disableHover: PropsTypes.bool,
    reversed: PropsTypes.bool,
};

export default ChartLegend;
